<div class="check-step step">
  <check [check]="checkStepView" [bold]="true"></check> 
</div>
